import React from 'react';
import { ConsumerAffairsLogoStyles } from './ConsumerAffairsLogo.styled';
import consumerAffairsLogo from "./consumer-affairs-shield.png";

const ConsumerAffairsLogo = () => (
    <ConsumerAffairsLogoStyles>
        <div className="consumer-affairs-logo">
            <img src={consumerAffairsLogo} alt="Consumer Affairs Accredited Logo"/>
        </div>
    </ConsumerAffairsLogoStyles>
)

export default ConsumerAffairsLogo;
